import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const Group: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.85714 6.92862C7.33648 6.92862 8.53571 5.72938 8.53571 4.25004C8.53571 2.77071 7.33648 1.57147 5.85714 1.57147C4.37781 1.57147 3.17857 2.77071 3.17857 4.25004C3.17857 5.72938 4.37781 6.92862 5.85714 6.92862ZM5.85714 8.00004C2.89848 8.00004 0.5 10.3985 0.5 13.3572V13.8929C0.5 14.1887 0.739848 14.4286 1.03571 14.4286H10.6786C10.9744 14.4286 11.2143 14.1887 11.2143 13.8929V13.3572C11.2143 10.3985 8.81581 8.00004 5.85714 8.00004ZM14.9643 14.4286H12.4759C12.5264 14.2589 12.5536 14.079 12.5536 13.8929V13.3572C12.5536 11.1703 11.5053 9.22831 9.8838 8.00619C9.96962 8.00211 10.056 8.00004 10.1428 8.00004C13.1015 8.00004 15.5 10.3985 15.5 13.3572V13.8929C15.5 14.1887 15.2601 14.4286 14.9643 14.4286ZM10.1428 6.92862C9.75204 6.92862 9.3808 6.84494 9.04606 6.69451C9.56594 6.01731 9.87496 5.16977 9.87496 4.25004C9.87496 3.33032 9.56594 2.48278 9.04606 1.80558C9.3808 1.65515 9.75204 1.57147 10.1428 1.57147C11.6222 1.57147 12.8214 2.77071 12.8214 4.25004C12.8214 5.72938 11.6222 6.92862 10.1428 6.92862Z"
      fill="currentColor"
    />
  </svg>
);
